import { FormattedMessage } from "react-intl";
import React from "react";
import ExportAvatarImg from "../../../../../images/home_export_avatar/home_export_avatar.svg";
import AdjustAvatarImg from "../../../../../images/home_adjust_avatar/home_adjust_avatar.svg";
import GroupAvatarImg from "../../../../../images/home_group_avatar/home_group_avatar.svg";
import FilterAvatarImg from "../../../../../images/home_filter_avatar/home_filter_avatar.svg";
import DatasetAvatarImg from "../../../../../images/home_dataset_avatar/home_dataset_avatar.svg";
import AnalyticsAvatarImg from "../../../../../images/home_analytics_avatar/home_analytics_avatar.svg";
//

export const cardSetting = [
  {
    title: (
      <FormattedMessage
        id="home.ourservice.feature.export.title"
        defaultMessage="檔案傳輸"
      />
    ),
    content: (
      <FormattedMessage
        id="home.ourservice.feature.export.introduction"
        defaultMessage="上傳個人資料集、匯出檔案以利網絡分析軟體進一步分析"
      />
    ),
    imgSrc: ExportAvatarImg,
  },
  {
    title: (
      <FormattedMessage
        id="home.ourservice.feature.adjust.title"
        defaultMessage="外觀設置"
      />
    ),
    content: (
      <FormattedMessage
        id="home.ourservice.feature.adjust.introduction"
        defaultMessage="調整網絡圖節點樣式、鏈結樣式、節點擺放樣式"
      />
    ),
    imgSrc: AdjustAvatarImg,
  },
  {
    title: (
      <FormattedMessage
        id="home.ourservice.feature.group.title"
        defaultMessage="團隊管理"
      />
    ),
    content: (
      <FormattedMessage
        id="home.ourservice.feature.group.introduction"
        defaultMessage="邀請他人與你一起編輯網絡資料"
      />
    ),
    imgSrc: GroupAvatarImg,
  },
  {
    title: (
      <FormattedMessage
        id="home.ourservice.feature.filter.title"
        defaultMessage="進階篩選"
      />
    ),
    content: (
      <FormattedMessage
        id="home.ourservice.feature.filter.introduction"
        defaultMessage="篩選資料並顯示網絡圖"
      />
    ),
    imgSrc: FilterAvatarImg,
  },
  {
    title: (
      <FormattedMessage
        id="home.ourservice.feature.dataset.title"
        defaultMessage="資料集控管"
      />
    ),
    content: (
      <FormattedMessage
        id="home.ourservice.feature.dataset.introduction"
        defaultMessage="建立專屬於你的個人資料集、共享團隊資料集"
      />
    ),
    imgSrc: DatasetAvatarImg,
  },
  {
    title: (
      <FormattedMessage
        id="home.ourservice.feature.analytics.title"
        defaultMessage="數據分析"
      />
    ),
    content: (
      <FormattedMessage
        id="home.ourservice.feature.analytics.introduction"
        defaultMessage="將網絡圖以數據分析呈現，提供更多視角檢視網絡"
      />
    ),
    imgSrc: AnalyticsAvatarImg,
  },
];
